import type { DeepString } from "@/lib/i18n";

/**
 * CCrmProjectManagement - polskie tłumaczenia publicznej strony zamawiania usługi.
 *
 * Etykiety cen mówią wprost, która kwota jest która - pakiety bywają liczone raz
 * od netto, raz od brutto (pole "Przeliczaj od" przy pakiecie), więc bez podpisu
 * odwiedzający nie wie, na co patrzy.
 */
export const pl = {
  emptyData: "Brak danych do wyświetlenia.",
  emptyOffer: "Nie mamy w tej chwili pakietów dostępnych do zamówienia online.",
  netto: "netto",
  brutto: "brutto",
  oneTime: "jednorazowo",
  recommended: "Polecany",
  priority: "Obsługa priorytetowa",
  formatTrial: (days: number) => `Testuj bezpłatnie przez ${days} dni`,
  formatPeriod: (period: string) => `/ ${period}`,

  /* Formularz zamówienia - drugi krok strony z ofertą. */
  orderCta: "Zamawiam",
  orderBack: "Wróć do oferty",
  orderLoading: "Wczytujemy formularz zamówienia...",
  orderLoadFailed: "Nie udało się wczytać formularza zamówienia.",
  orderSummaryPrice: "Do zapłaty",
  orderNoAccountTypes:
    "Zamawianie online nie jest jeszcze skonfigurowane - skontaktuj się z nami, złożymy zamówienie za Ciebie.",
  orderHaveAccount: "Mam już konto - zaloguj się",
  orderLoginHide: "Wypełnię dane bez logowania",
  orderLoginField: "Login lub adres e-mail",
  orderPasswordField: "Hasło",
  orderLoginSubmit: "Zaloguj się",
  orderLoginFailed: "Nie udało się zalogować.",
  orderLoginMfa:
    "Twoje konto wymaga dodatkowego potwierdzenia logowania. Zaloguj się na stronie konta i wróć do zamówienia.",
  orderLoggedDataNote:
    "Dane pobraliśmy z Twojego konta. Popraw je, jeśli na fakturze mają być inne - zapiszemy je razem z zamówieniem.",
  orderAccountTypeLegend: "Zamawiam jako",
  orderAccountCompany: "Firma",
  orderAccountPrivate: "Osoba prywatna",
  orderSectionContact: "Dane kontaktowe",
  orderSectionCompany: "Dane firmowe",
  orderSectionCompanyHint: "Te dane trafią na fakturę za usługę.",
  orderSectionBilling: "Dane do faktury",
  orderProjectLegend: "Projekt",
  orderProjectNew: "- nowy projekt -",
  orderProjectHint:
    "Usługa zostanie dopięta do wybranego projektu. Wybierz nowy projekt, jeśli to osobne zlecenie.",
  orderTrialHint:
    "Test uruchamia usługę od razu, bez płatności i bez faktury. Po jego zakończeniu usługę można przedłużyć.",
  orderGusFetch: "Pobierz dane firmy z GUS po numerze NIP",
  orderGusBusy: "Pobieramy dane z rejestru...",
  orderGusFilled: "Dane firmy uzupełnione z rejestru REGON. Sprawdź je przed wysłaniem.",
  orderGusNotFound: "Nie znaleźliśmy firmy o tym numerze NIP w rejestrze REGON.",
  orderGusNipRequired: "Wpisz numer NIP, żeby pobrać dane z rejestru.",
  orderSelectEmpty: "- wybierz -",
  orderDictionaryLoading: "Wczytujemy listę...",
  orderDictionaryFailed: "Nie udało się wczytać listy do wyboru.",
  orderRegulaminLegend: "Regulamin",
  orderRegulaminAccept: "Akceptuję regulamin usługi",
  orderRegulaminShow: "Pokaż treść regulaminu",
  orderRegulaminHide: "Ukryj treść regulaminu",
  orderRegulaminRequired: "Zamówienie wymaga akceptacji regulaminu.",
  orderFieldRequired: "To pole jest wymagane.",
  orderFieldInvalidUrl: "Podaj poprawny adres strony, np. https://twojafirma.pl",
  orderFieldExample: "Na przykład:",
  orderFieldInvalidDate: "Podaj datę w formacie RRRR-MM-DD.",
  orderFieldInvalidNumber: "Podaj liczbę.",
  orderFieldInvalidDigit: "Podaj liczbę całkowitą, bez części dziesiętnej.",
  orderFieldBelowMin: "Wartość nie może być mniejsza niż {min}.",
  orderFieldMinHint: "Minimalna wartość: {min}.",
  orderEmailRequired: "Podaj adres e-mail - na niego wyślemy dostęp do panelu klienta.",
  orderSubmitPaid: "Zamawiam i przechodzę do płatności",
  orderSubmitFree: "Zamawiam",
  orderSubmitTrial: "Uruchom bezpłatny test",
  orderPaymentLink: "Przejdź do płatności",
  orderPasswordEmail:
    "Założyliśmy Ci konto. Na podany adres wysłaliśmy link do ustawienia hasła - po jego ustawieniu zalogujesz się do panelu klienta.",
  formatOrderTitle: (name: string) => `Zamówienie: ${name}`,
  formatOrderLoggedAs: (name: string) => `Zamawiasz jako ${name}.`,
  formatOrderTrialHeading: (days: number) => `Możesz przetestować bezpłatnie przez ${days} dni`,
  formatOrderTrialSummary: (days: number) => `Bezpłatny test: ${days} dni, bez płatności.`,
} as const;

export type CCrmProjectManagementTranslations = DeepString<typeof pl>;
